import { connect } from "react-redux";

import GlobalCountryInfoPanel from "../../components/visualizations/global_country_info_panel";

const mapStateToProps = (state) => {
  const tabLoading = state.main.loading.tabIsLoading;
  const countrySelected = !!state.main.filters.country.selectedValue;
  const countryName = countrySelected ? state.main.filters.country.selectedValue.label : null;
  const tariffIncrease = state.main.loading.loadedData.tariffIncrease;
  const tariffIncreaseGlobal = state.main.loading.loadedData.tariffIncreaseGlobal;
  const tariffIncreaseGlobalExcludeHarare = state.main.loading.loadedData.tariffIncreaseGlobalExcludeHarare;
  const filterYear = state.main.filters.year.selectedValue.value;
  const averagePrice = state.main.loading.loadedData.averagePrice;
  const averagePriceGlobal = state.main.loading.loadedData.averagePriceGlobal;
  const surveyedCities = state.main.loading.loadedData.surveyedCities;
  const surveyedCitiesGlobal = state.main.loading.loadedData.surveyedCitiesGlobal;
  const countryNotSurveyedMessage = state.main.loading.loadedData.countryNotSurveyedMessage;

  const newThisYear = state.main.loading.loadedData.newThisYear;
  const newThisYearGlobal = state.main.loading.loadedData.newThisYearGlobal;

  return {
    tariffIncrease, filterYear, averagePrice, surveyedCities, countrySelected,
    countryName, tabLoading, countryNotSurveyedMessage, tariffIncreaseGlobal, averagePriceGlobal, surveyedCitiesGlobal,
    newThisYear, newThisYearGlobal, tariffIncreaseGlobalExcludeHarare
  };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalCountryInfoPanel);
